<template>
  <div class="bankari-app-root">
    <workspace-tabs v-if="showWorkspaces" :user="me" @session-ended="endSession" />
    <router-view v-else style="height:100%" />
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import WorkspaceTabs from '@/components/shared/WorkspaceTabs.vue';
import {isWorkspaceFrame, WORKSPACE_CHANNEL, workspaceNavigationState, componentHasDirtyForm} from '@/utils/brokerWorkspaces';

export default {
  name: "App",
  components: {WorkspaceTabs},
  created () {
    let html = document.getElementsByTagName("html")[0];
    html.style.overflowX = "hidden";
    html.style.overflowY = "auto";
  },
  mounted () {
    AOS.init();
    if (!this.embedded) return;
    this.frameBridge = {
      navigate: path => this.$router.push(path).catch(() => {}),
      goHistory: delta => {
        const state = workspaceNavigationState(this.$router);
        if ((delta !== -1 && delta !== 1) || !(delta < 0 ? state.canGoBack : state.canGoForward)) return false;
        this.$router.go(delta); return true;
      },
      reportState: this.reportState,
      hasDirtyForm: () => this.edited || componentHasDirtyForm(this),
    };
    window.__bankariWorkspaceFrame = this.frameBridge;
    this.removeHistoryListener = this.$router.afterEach(this.reportState);
    document.addEventListener('input', this.trackEdits, true);
    document.addEventListener('change', this.trackEdits, true);
    this.$router.onReady(() => { this.frameReady = true; this.reportState(); });
  },
  data: () => ({embedded: isWorkspaceFrame(window), frameBridge: null, frameReady: false, edited: false, removeHistoryListener: null}),
  computed: {
    me() { return this.$store.getters['userState/getMe']; },
    logged() { return this.$store.getters['userState/getLogged']; },
    showWorkspaces() { return !this.embedded && this.logged && !!this.me?.id && !!this.$route.name && this.$route.name !== 'Landing'; },
  },
  watch: {
    '$route.fullPath'() { this.edited = false; this.reportState(); },
    me() { this.reportState(); },
    logged() { this.reportState(); },
  },
  beforeDestroy() {
    this.removeHistoryListener?.();
    document.removeEventListener('input', this.trackEdits, true);
    document.removeEventListener('change', this.trackEdits, true);
    if (window.__bankariWorkspaceFrame === this.frameBridge) delete window.__bankariWorkspaceFrame;
  },
  methods: {
    trackEdits(event) { if (event.target?.matches?.('input, textarea, select, [contenteditable="true"]') && !['search', 'button', 'submit'].includes(event.target.type)) this.edited = true; },
    reportState() {
      if (!this.embedded || !this.frameReady) return;
      const data = !this.me || !this.logged || this.$route.name === 'Landing'
        ? {channel: WORKSPACE_CHANNEL, type: 'session-ended'}
        : {channel: WORKSPACE_CHANNEL, type: 'state', userId: this.me.id, role: this.me.role,
          route: this.$route.fullPath, ...workspaceNavigationState(this.$router)};
      window.parent.postMessage(data, window.location.origin);
    },
    endSession() {
      this.$store.commit('userState/setLogged', {logged: false});
      this.$store.commit('userState/setMe', null);
      this.$store.commit('appState/setEntryUrl', null);
      this.$router.replace({name: 'Landing'}).catch(() => {});
    },
  },
};
</script>

<style>
.bankari-app-root{height:100%}
.v-main__wrap {
  background-color: var(--app-bg) !important;
}
</style>
